export const ENV = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  REACT_APP_ENV: process.env.REACT_APP_ENV || 'development',
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Bethel Church',
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  USE_MOCK_DATA: process.env.REACT_APP_USE_MOCK_DATA === 'true' || process.env.NODE_ENV === 'development',
};

export const isDevelopment = ENV.NODE_ENV === 'development';
export const isProduction = ENV.NODE_ENV === 'production';
export const isStaging = ENV.REACT_APP_ENV === 'staging';
export const useMockData = ENV.USE_MOCK_DATA;